export default {"src":"https://fishbrain.com/_next/static/media/ohio.6b2215b4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};